export function validateMaxText(truncate: number, text: string) {
  if (text.length < truncate) {
    return text;
  } else {
    return `${text.substr(0, truncate)}...`;
  }
}
